import React, { Component } from 'react'
import { Form, Grid, Image, Checkbox } from 'semantic-ui-react'
import { connect } from 'react-redux'
import InputField from '../formComponents/inputField'
import { DropDown } from '../formComponents/dropDown'
import Images from '../config/images'
import * as actionCreators from '../actions'
import { saveEntryTypeDateField, saveImporterField, saveEntryTypeField as saveEntryTypeFieldNoRedux, calcEntryDateToPSPDDate } from '../api/setFormData'
import CustomCheckBox from '../formComponents/checkBox'
import { updateAndSaveTotals } from '../actions/DescriptionOfMerchandiseActions'
import store from "../store";
import { months, monthNumberToMonth } from './util/constants'
import SearchDropDown from '../formComponents/searchDropDown'
import { displayMasterItem } from './util'
import { businessDaysFromDate } from "kx-common-components"
import PopUpIcon from '../formComponents/PopUpIcon'
import { entryTypeFields } from '../util/supportedFields/entryType'
import PscHeaderReason from "./headerReason";
import {fetchSelectedReasonCodes, totalHeaderReasonSelected} from "../util";
import { bolAwbFields } from '../util/supportedFields/bolAwbForm'
import SearchFirmList from '../formComponents/searchFirmList'
import { transportationFields } from "../util/supportedFields/transportationForm";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
import { get } from "lodash";
import {
  convertToTimezone,
  listOfWarehouseWithdrawlEntryTypes
} from "../../util";


// Date.prototype.addMonths = function (value) {
//   return new Date(this.getUTCFullYear(),this.getUTCMonth()+value,6);
// };



const SameAsHeader = ({
  checkboxValue,
  handleCheckBoxChange,
  headerPartyType,
  label,
  disabled
}) => {
  if (headerPartyType === 'SELLER') return null
  return (
    <Form.Group>
      <CustomCheckBox
        label={label}
        value={checkboxValue}
        update={handleCheckBoxChange}
        disabled={disabled}
      />
    </Form.Group>
  )
}

class EntryTypeForm extends Component {
  constructor() {
    super()
    this.state = {
      formInfo: {},
      entryNumberTouched: false,
      renderTime: Date.now(),
    }
    this.updateValidEntryNumber = this.updateValidEntryNumber.bind(this)
    this.addErrorClass = this.addErrorClass.bind(this)
    this.removeErrorClass = this.removeErrorClass.bind(this)
    this.validateField = this.validateField.bind(this)
    for (let key in entryTypeFields) {
      entryTypeFields[key].errors = []
      entryTypeFields[key].valid = []
    }
  }

  addErrorClass(fieldName, fieldType) {
    const inputField = document.querySelector('#' + fieldName + window.shipmentId)
    if(inputField){
      inputField.classList.add('errorInput')
    }
  }

  removeErrorClass(fieldName, fieldType) {
    try {
      const inputField = document.querySelector('#' + fieldName + window.shipmentId)
      if(inputField && inputField.classList){
        inputField.classList.remove('errorInput')
      }
    } catch (e) {
      console.error(e)
    }
  }

  enableDisableFrom = (enableForm) => {
    this.setState({
      "enableForm": enableForm
    })
  }
  updateValidEntryNumber(validEntryNumber) {
    if (validEntryNumber) {
      this.setState({
        validEntryNumber: validEntryNumber
      })
      this.setState({
        entryNumberWarning: ''
      })
    }
    if (
      this.state.validEntryNumber !== this.props.entryTypeValues.entryNumber
    ) {
      this.props.updateEntryTypeField(
        'entryNumber',
        this.state.validEntryNumber
      )
      this.setState({
        entryNumberWarning: 'Invalid Entry Number, Try Another'
      })
    }
  }

  validateField(fieldName, value) {
    const newState = Object.assign({}, this.state)
    let warning = 0
    newState.formInfo[fieldName] = value
    this.setState(newState)
    
    if(!entryTypeFields[fieldName]){
      console.error("Validation not defined for "+fieldName)
      return;
    }
    entryTypeFields[fieldName].errors = []
    entryTypeFields[fieldName].valid = true
    if (
      entryTypeFields[fieldName].rules &&
      entryTypeFields[fieldName].rules.length > 0
    ) {
      entryTypeFields[fieldName].rules.forEach(rule => {
        if (rule.test instanceof RegExp) {
          if (!rule.test.test(value)) {
            entryTypeFields[fieldName].errors.push(rule.message)
            entryTypeFields[fieldName].valid = false
          }
        } else if (typeof rule.test === 'function') {
          console.log(rule.test(value))
          if (!rule.test(value, this.props)) {
            entryTypeFields[fieldName].errors.push(rule.message)
            entryTypeFields[fieldName].valid = false
          }
        }
      })
    }
    Object.keys(entryTypeFields).forEach(field => {
      if (!entryTypeFields[field].valid) {
        warning++
      }
    })
    this.props.updateEntryTypeErrorWarning(warning)
    if (entryTypeFields[fieldName].errors.length) {
      this.addErrorClass(fieldName, entryTypeFields)
    } else {
      this.removeErrorClass(fieldName, entryTypeFields)
    }
  }

  displayEntryNumberError = () => {
    return (
      <span className='error' style={{ position: 'absolute' }}>
        * {this.state.entryNumberWarning}
      </span>
    )
  }

  componentDidMount() {
    let {
      entryTypeValues,
      isDisabled,
    } = this.props
    this.selectedReasons = this.props.pscData.headerCodes ? fetchSelectedReasonCodes(this.props.pscData.headerCodes, this.props.tabName): []
    const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
    this.enableDisableFrom(isTheOwningBroker && this.selectedReasons.length>0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY'));
  }
  componentWillMount() {
    this.selectedReasons = this.props.pscData.headerCodes ? fetchSelectedReasonCodes(this.props.pscData.headerCodes, this.props.tabName): []
    const isTheOwningBroker = !this?.props?.kxUserBasicInfo?.userGuid ||  !this?.props?.currentJobData?.brokerGuid || this?.props?.kxUserBasicInfo?.userGuid  == this?.props?.currentJobData?.brokerGuid;
    this.enableDisableFrom(isTheOwningBroker && this.selectedReasons.length>0 && (get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY'));
  }
  render() {
    let {
      dropDownValues,
      entryTypeValues,
      updateEntryTypeField,
      saveEntryTypeField,
      updateEntryTypeObject,
      getCheckDigitAndSaveEntryNumber,
      saveEntryNumberAndCheckDigit,
      newValue,
      fieldName,
      setINPUTID,
      penClicked,
      shipmentId,
      countryList,
      entryTypeList,
      formDisabled,
      rbCounterID,
      isDisabled,
      modeOfTransport,
      saveHeaderReason,
      fieldValidation,
      BOLInfo,
      USportOfUnladingCode,
      bolInfoValues,
      updateBOLInfoField,
      saveBOLInfoField,
      updateITDateField,
      updateTransportationField,
      saveBOLInfoObject,
      saveTransportationField,
      updateTransportDate,
      saveTransportationDateField,
      related,
      updateField,
      centralizedExaminationSite,
      FIELD_META,
      pscChainRawResponse,
      transportInfoValues
    } = this.props
    
    const showCurrentLocationOfGood = entryTypeValues.entryType == 21;
    const isActivePscChild = pscChainRawResponse?.activeChildId == shipmentId;

    fieldValidation.validObjects_bl = fieldValidation.validObjects_bl||{};
    let massageEntryTypeList = (entryTypeList)=>{
      let newlist =[
        '01' ,
        '02',
        '03',
        '07',
        '11',
        '12',
        '23',
        '22',
        '21',
        '34',
        '31',
        '32',
        '38',
      ]
      return (entryTypeList||[])
        .filter(a=>newlist.includes(a.id) || newlist.includes('0'+a.id))
        .sort((a,b)=>a.id-b.id)

    }
    const getStatementPaymentTypeDropdownOptions = (options, value) => {
      return value === "MONTHLY" ? (options || []).filter(option => !(option.stringVal === "DAILY_BROKER")): options
    }

    let changePSPDMonth = entryDateMonth =>{
      console.log('entryDateMonth: ', entryDateMonth);
      let releaseDateFutureMonth = null;
      if(entryTypeValues?.releaseDate?.epochs >= 100000){
        releaseDateFutureMonth = new Date(entryTypeValues?.releaseDate?.epochs) .addMonths(1).getMonth() + 1
      }//if we have a release date, use that for the month instead!
      let futuremonthasNumNormalized = releaseDateFutureMonth || (entryDateMonth.addMonths(1).getMonth() + 1);
      saveEntryTypeFieldNoRedux(
        ['periodicStatementMonths'],
        futuremonthasNumNormalized.toString().padStart(2, '0')
      ).then((responsecc) => {
        if (get(responsecc, "status") == 200) {
          updateEntryTypeField(
            'periodicStatementMonths',
            futuremonthasNumNormalized.toString().padStart(2, '0')
          )
        }
      });
      

    }

    let changeEntryDate = value => {
      console.log('value: ', value);
      //value = value && new Date(value.toGMTString());
      let dateAsMMDDYYYY =  `${(((new Date(value)).getMonth()+1)+"").padStart(2,"0")}${(((new Date(value)).getDate())+"").padStart(2,"0")}${new Date(value).getFullYear()}`
      this.validateField('summaryDate', value)
      if (value && value !== -999 && !isNaN(value.getTime())) {
        value = value.getTime();
        value = new Date(Date.UTC((new Date(value)).getFullYear(), (new Date(value)).getMonth(), (new Date(value)).getDate()))
       
       
        saveEntryTypeDateField('summaryDate', value.getTime()).then((responsecc) => {
          let eventmessage = get(responsecc,"data.eventMessage")
          if(eventmessage && eventmessage.hmf && eventmessage.mpf){
              store.dispatch(updateAndSaveTotals(eventmessage.hmf.fee, eventmessage.mpf.fee,
            eventmessage.duty, eventmessage.fee, 
            eventmessage.tax, 
            eventmessage.additionalDuties,
            eventmessage.bondedAdDutyAmt,
            eventmessage.bondedCvdDutyAmt,
            eventmessage.cashAdDutyAmt,
            eventmessage.cashCvdDutyAmt,
            eventmessage.grandTotal,
            eventmessage))
          }  
          if (get(responsecc, "status") == 200) {
            updateEntryTypeObject(
              'summaryDate',
              'epochs',
              value.getTime()
            )
          }

        // Update/Save Preliminary Statement PrintDate
        calcEntryDateToPSPDDate(dateAsMMDDYYYY,this.props.shipmentId, this.props?.kxUserBasicInfo?.fullName).then((calcPSPDResponse)=>{
          // if(
          //   calcPSPDResponse.data.eventMessage.pspdInMs !=
          //   businessDaysFromDate(value, businessDaysAheadForPrelim).getTime()
          //   ){
          //     alert("PSPD CALCULATION MAY HAVE FAILED! "+calcPSPDResponse.data.eventMessage.pspdInMs+" vs "+businessDaysFromDate(value, businessDaysAheadForPrelim).getTime())
          // }

          saveEntryTypeDateField(
            'primaryStatementPrintDate',
            calcPSPDResponse.data.eventMessage.pspdInMs
          ).then((responsecc) => {
            if (get(responsecc, "status") == 200) {
              updateEntryTypeObject(
                'primaryStatementPrintDate',
                'epochs',
                calcPSPDResponse.data.eventMessage.pspdInMs
              )

            }

            changePSPDMonth(value);
          })
        })
      });


      } else {
        updateEntryTypeObject('summaryDate', 'epochs', -999)
        saveEntryTypeDateField('summaryDate', -999)

        // Update/Save Preliminary Statement PrintDate
        updateEntryTypeObject(
          'primaryStatementPrintDate',
          'epochs',
          -999
        )
        saveEntryTypeDateField('primaryStatementPrintDate', -999)

        // Update/Save Periodic Statement Month
        updateEntryTypeField('periodicStatementMonths', 'NONE')
        saveEntryTypeField('periodicStatementMonths', 'NONE')
      }
      this.validateField(entryTypeFields.itDate.id, bolInfoValues?.itDate?.epochs)
      setTimeout(()=>
       {document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();}
      ,200)
    };

    
    let statementPaymentType = 
      entryTypeValues.statementPaymentType?.stringVal
        ? entryTypeValues.statementPaymentType?.stringVal
        : entryTypeValues.statementPaymentType;
    let shipment = document.getElementById("summaryDate"+this.props.shipmentId);
    let isIndividual =  statementPaymentType == "INDIVIDUAL";
    let PSPDDisabledOnForm = this.state.enableForm === true ? false : isDisabled('entryTypeSection');


    let releaseDate = get(entryTypeValues,"releaseDate.epochs",-999);
    let hasLoadedYet = this.state.renderTime - Date.now() + 8000 < 0; 
    
    let autoAddPSPD = ()=>{
      if(shipment && !isIndividual && !PSPDDisabledOnForm && !this.state.hasAutoPSPD && entryTypeValues?.summaryDate?.epochs && ((releaseDate||0) < 10000)){
        this.setState({hasAutoPSPD:true})
        var primarystatementprintdate = document.getElementById("primaryStatementPrintDate"+this.props.shipmentId)
        let missingPeriodicStatementMonth = !entryTypeValues.periodicStatementMonths && (JSON.stringify(entryTypeValues.statementPaymentType)||"").includes("MONTH");
        if((primarystatementprintdate && !primarystatementprintdate.value) || missingPeriodicStatementMonth){
          changeEntryDate(new Date(entryTypeValues?.summaryDate?.epochs + (new Date().getTimezoneOffset() * 60 * 1000)));
        }
      }
    }
    let businessDaysAheadForPrelim = 8;
    let arrivalDate = get(transportInfoValues, "arrivalDate.epochs", "-999");
    let itDateHtml = (BOLInfo.itDate.epochs && BOLInfo.itDate.epochs > 100000)?
      <>{
        (new Date(BOLInfo.itDate.epochs).getUTCMonth()+1) +"/"+
        new Date(BOLInfo.itDate.epochs).getUTCDate() +"/"+
        new Date(BOLInfo.itDate.epochs).getUTCFullYear()
        }
      </>
      :
        <>None</>
        let itNumberHTML = (!BOLInfo.itNumber || BOLInfo.itNumber == '_BLANK_')?"":BOLInfo.itNumber
      
    let monthOfRelease = new Date(entryTypeValues?.releaseDate?.epochs).getUTCMonth()+1;
    const hasPSC = get(this.props, 'pscState.value.state') === 'STATE_PSC_IN_PROCESS' ||  get(this.props, 'pscState.value.state') === 'STATE_PSC_READY';
    let pscWarningAlertShow = this.selectedReasons.length<=0 && hasPSC;
    let statementBranchHash ={
      "CWL" : "R1",
      "609" : "10",
      "DZ1" : "KN",
      "B8P" : "CM",
    }
    for(let onetpye of entryTypeList){
      const isAnyKindOfWarehouse = listOfWarehouseWithdrawlEntryTypes.includes(onetpye.id);
      if(isAnyKindOfWarehouse){
        onetpye.disabled=true;
      }
    }
    return (
      <Form autoComplete='off'  title={pscWarningAlertShow?"Must select a PSC reason before you can edit":""}>
       {
        (get(this.props, "pscData.pscShipmentId") || this.props.isAPscShipment) && 
         <PscHeaderReason 
         {...this.props} 
         totalHeaderReasonSelected={totalHeaderReasonSelected(this.props.pscData)}
         pscState={get(this.props, "pscState.value.state")}
         selectedOptions={this.selectedReasons}
         saveHeaderReason={saveHeaderReason} 
         enableDisableFrom={this.enableDisableFrom}/>
       }
       
        <div style={{padding:'5px'}}><SameAsHeader
          id='related'
          dropDownValue='Importer'
          dropDownValues={['Importer']}
          label='CHECK HERE WHEN THE TRANSACTION IS BETWEEN RELATED PARTIES'
          handleCheckBoxChange={value => {
            updateField('related', value ? 1 : 2)
            saveImporterField('related', value ? 1 : 2)
          }}
          handleDropDownChange={() => { }}
          checkboxValue={Boolean(related === 1)}
          disabled={(this.state.enableForm === true ? false : isDisabled('related'))}
        />
        </div>
        <Grid width='equal' className='no-gutters'>
          <Grid.Row className='fourColoumnMerge row-1' style={{flexWrap: 'nowrap'}}>
            <Grid.Column width={'3'} className='firstCol no-field-margin'>
              <DropDown
                id='entryType'
                label='Entry Type'
                disabled={
                  
                  listOfWarehouseWithdrawlEntryTypes.includes(entryTypeValues.entryType) ||
                  (this.state.enableForm === true ? false : isDisabled('entryTypeEntryDateEnabled'))}
                className='field-bg dropdown100 showDisabledItems'
                labelClass='text-none'
                isLabel={true}
                errors={entryTypeFields['entryType'].errors}
                text={displayMasterItem(
                  entryTypeValues.entryType === '_BLANK_'
                    ? 'NONE'
                    : entryTypeValues.entryType,
                  entryTypeList
                )}
                data={massageEntryTypeList(entryTypeList)}
                onChange={value => {
                  document.getElementById("RERENDER__BUTTONS") &&document.getElementById("RERENDER__BUTTONS").click();

                  updateEntryTypeField('entryType', value)
                  saveEntryTypeField(
                    'entryType',
                    value === 'NONE' ? '_BLANK_' : value
                  )
                  if(value !== "21" && ![" ", ""].includes(bolInfoValues.currentLocationOfGood)){
                    saveBOLInfoObject(
                      'bolInfo',
                      {"currentLocationOfGood": " "}
                    )
                  }
                  this.validateField('entryType', value)
                  document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();
                  if(value == 23){
                    
                    confirmAlert({
                      closeOnClickOutside: false,
                      title: `When TIB has been filed successfully, please ensure you submit supporting documents to DIS.`,
                      buttons: [
                        {label: `Ok`, onClick: () => { }}
                      ]
                    })
                  }
                }}
                onBlur={value =>{
                  autoAddPSPD();
                }}
              />
              {/* {this.displayValidationErrors('entryType')} */}
            </Grid.Column>
            <Grid.Column
              width={'3'}
              className={'secondCol datepicker no-field-margin '}
            >
              <InputField
                icon={<Image src={Images.calender_icon} />}
                isLabel={false}
                id='summaryDate'
                labelIcon={releaseDate>1000?
                  <PopUpIcon basic={true} icon='info circle' popupText={'Release Date is set, can no longer change Entry Date'} />
                :null}
                disabled={isActivePscChild || releaseDate>1000  || (this.state.enableForm === true ? false : isDisabled('entryTypeEntryDateEnabled'))}
                type='date'
                label='Entry Date'
                placeholder='Summary Date'
                className={'field-bg'}
                value={entryTypeValues?.summaryDate?.epochs ? new Date((new Date(entryTypeValues?.summaryDate?.epochs).getUTCMonth()+1)+"/"+new Date(entryTypeValues?.summaryDate?.epochs).getUTCDate()+'/'+new Date(entryTypeValues?.summaryDate?.epochs).getUTCFullYear()).getTime(): -999}
                //value={entryTypeValues.summaryDate.epochs}
                shipmentId={shipmentId}
                
                errors={fieldValidation.validObjects_bl[`Entryqwqr${'summaryDate'}`] || entryTypeFields['summaryDate'].errors}
                onChange={changeEntryDate}
                onBlur={value => {
                }}
              />
              {/* {this.displayValidationErrors('summaryDate')} */}
            </Grid.Column>
            <Grid.Column
              width={'2'}
              className={'secondCol datepicker no-field-margin '}
            >
              <InputField
                isLabel={false}
                id='releaseDate'
                disabled={true}
                type='date'
                label='Release Date'
                className={'field-bg'}
                value={entryTypeValues?.releaseDate?.epochs ? new Date((new Date(entryTypeValues?.releaseDate?.epochs).getUTCMonth()+1)+"/"+
                                                            new Date(entryTypeValues?.releaseDate?.epochs).getUTCDate()+'/'+
                                                            new Date(entryTypeValues?.releaseDate?.epochs).getUTCFullYear()).getTime(): -999}
                //value={entryTypeValues.summaryDate.epochs}
                shipmentId={shipmentId}
                
              />
              {/* {this.displayValidationErrors('summaryDate')} */}
            </Grid.Column>
            {/* <Grid.Column width={'3'} className='thirdCol'>
              <InputField
                isLabel={false}
                id='filerCode'
                type='text'
                label='Filer Code'
                placeholder='Filer Code'
                className='field-bg noBottomBorders'
                value={entryTypeValues.filerCode}
                disabled={true || Boolean(formDisabled)}
                onChange={value => updateEntryTypeField('filerCode', value)}
                onBlur={value => saveEntryTypeField('filerCode', value)}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
                clearInput={true}
              />
            </Grid.Column>
            <Grid.Column width={'3'} className='thirdCol no-field-margin'>
              <InputField
                isLabel={false}
                id='entryNumber'
                type='text'
                label='Entry Number'
                placeholder='Entry Number'
                className={'field-bg noBottomBorders'}
                value={entryTypeValues.entryNumber}
                disabled={this.state.enableForm === true ? false : formDisabled}
                maxlength={7}
                handleFocus={e => {
                  e.target.select()
                  this.setState({
                    entryNumberTouched: false,
                    validEntryNumber: entryTypeValues.entryNumber
                  })
                }}
                onChange={value => {
                  this.setState({
                    entryNumberTouched: true
                  })
                  updateEntryTypeField(
                    'entryNumber',
                    value.replace(/[^\d]/g, '')
                  )
                }}
                onBlur={value => {
                  // Only update if the entry number was touched
                  // if (this.state.entryNumberTouched && value.length === 7) {
                  //   getCheckDigitAndSaveEntryNumber(
                  //     value === '' ? '_BLANK_' : value,
                  //     this.updateValidEntryNumber
                  //   )
                  // }
                  // this.validateField('entryNumber', value)
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
                errors={entryTypeFields['entryNumber'].errors}
              // clearInput={true}
              />
            </Grid.Column>
            <Grid.Column width={'2'} className='lastCol no-field-margin noBorderRadius'>
              <InputField
                isLabel={false}
                id='checkDigit'
                type='text'
                labelIcon={
                  <PopUpIcon icon='info circle' popupText='Check Digit' />
                }
                className={'field-bg check-digit noBottomBorders'}
                value={entryTypeValues.checkDigit}
                disabled={this.state.enableForm === true ? false : formDisabled}
                onChange={value => {
                  updateEntryTypeField(
                    'checkDigit',
                    value.toString().match(/[\d]{1}\b/)[0]
                  )
                }}
                onBlur={value => {
                  saveEntryNumberAndCheckDigit(
                    entryTypeValues.entryNumber,
                    value
                  )
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
              />
            </Grid.Column> */}
          {/* </Grid.Row>
          <Grid.Row className='fourColoumnMerge blk2 row-1'> */}
            <Grid.Column width='3' className='firstCol'>
              <DropDown
                id='statementPaymentType'
                disabled={isActivePscChild || (this.state.enableForm === true ? false : isDisabled('entryTypeSection'))}
                label='Statement Payment Type'
                className='field-bg dropdown100'
                labelClass='text-none'
                isLabel={true}
                errors={entryTypeFields['statementPaymentType'].errors}
                text={
                  entryTypeValues.statementPaymentType?.stringVal
                    ? entryTypeValues.statementPaymentType?.stringVal
                    : entryTypeValues.statementPaymentType
                }
                data={getStatementPaymentTypeDropdownOptions(dropDownValues.statementPaymentTypeList, entryTypeValues.statementPaymentType)}
                onChange={value => {
                  updateEntryTypeField(
                    'statementPaymentType',
                    value === 'NONE' ? '_BLANK_' : value
                  )
                  saveEntryTypeField('statementPaymentType', value)
                  this.validateField('statementPaymentType', value)
                  if((value||"").includes("MONTH")){
                    changePSPDMonth(new Date(entryTypeValues?.summaryDate?.epochs));
                  }
                }}
              />
              {/* {this.displayValidationErrors('statementPaymentType')} */}
            </Grid.Column>
                {window.DEBUG_CORE_25746 && <input type='button'  id='clearMonth' onClick={()=>{
                            updateEntryTypeField('periodicStatementMonths', '_BLANK_')
                            saveEntryTypeField(
                              'periodicStatementMonths','NONE'
                            )
                            document.getElementById("VALIDATE_FORM_BUTTON") &&
                              document.getElementById("VALIDATE_FORM_BUTTON").click();

                }} value={`clear month ${entryTypeValues.periodicStatementMonths}`}/>
              }
            {(entryTypeValues.statementPaymentType === 'MONTHLY' || entryTypeValues.statementPaymentType === 'MONTHLY_BROKER') ? (
              <Grid.Column width={'2'} className='lastCol'>
                <DropDown
                  id='periodicStatementMonths'
                  label={<>
                    {releaseDate > 1000 ?
                      <PopUpIcon basic={true} icon='info circle' popupText={'Release Date is set, can no longer change Periodic Statement Month'} />
                      : <></>
                    }
                    PERIODIC STATEMENT MONTH</>
                  }
                  className='field-bg dropdown100'
                  labelClass='text-none'
                  isLabel={true}
                  data={
                    releaseDate > 1000?
                    months.filter(a=>(a.id==monthOfRelease || (a.id - 1) == monthOfRelease) || (a.id - 1 == 0 && monthOfRelease == 12))
                    :
                    months}
                  text={displayMasterItem(
                    entryTypeValues.periodicStatementMonths,
                    months
                  )}
                  errors={entryTypeFields['periodicStatementMonths'].errors}
                  onChange={value => {
                    
                    confirmAlert({
                      title: `Confirm the preliminary statement month ${monthNumberToMonth(value)}`,
                      message: <></>,
                      buttons: [
                        {
                          label: <b>Confirm</b>,
                          onClick: () => {
                            updateEntryTypeField('periodicStatementMonths', value)
                            saveEntryTypeField(
                              'periodicStatementMonths',
                              value === 'NONE' ? '_BLANK_' : value
                            )
                            document.getElementById("VALIDATE_FORM_BUTTON") &&
                              document.getElementById("VALIDATE_FORM_BUTTON").click();

                          }
                        },
                        {
                          label: `Cancel`,
                          onClick: () => {}
                        }
                      ]
                    })
                  }}
                  
                  disabled={isActivePscChild || releaseDate > 1000 || (this.state.enableForm === true ? false : isDisabled('entryTypeSection'))}
                />
                {/* {this.displayValidationErrors('periodicStatementMonths')} */}
              </Grid.Column>
            ) : (
                <Grid.Column
                  width={'5'}
                  className='lastCol datepicker primary-days no-field-margin noBorderRadius'
                >
                  <InputField
                    isLabel={false}
                    id='primaryStatementPrintDate'
                    type='date'
                    label='Preliminary Statement Print Date'
                    className={'field-bg'}
                    labelClassName='city'
                    disabled={this.state.enableForm === true ? false : isDisabled('entryTypeSection')}
                    value={entryTypeValues.primaryStatementPrintDate.epochs ? new Date((new Date(entryTypeValues.primaryStatementPrintDate.epochs).getUTCMonth()+1)+"/"+new Date(entryTypeValues.primaryStatementPrintDate.epochs).getUTCDate()+'/'+new Date(entryTypeValues.primaryStatementPrintDate.epochs).getUTCFullYear()).getTime(): -999}
                    //value={entryTypeValues.primaryStatementPrintDate.epochs}
                    shipmentId={shipmentId}
                    errors={(entryTypeFields['primaryStatementPrintDate'].errors || []).concat(fieldValidation.validObjects_bl[`Entryqwqr${'primaryStatementPrintDate'}`] || [])}
                    onChange={value => {
                      //value = value && new Date(value.toGMTString());
                      if (value && !isNaN(value.getTime())) {
                        value = value.getTime()
                        value = new Date(Date.UTC((new Date(value)).getFullYear(), (new Date(value)).getMonth(), (new Date(value)).getDate()))
                        value = value.getTime();
                      } else value = -999
                      updateEntryTypeObject(
                        'primaryStatementPrintDate',
                        'epochs',
                        value
                      )
                      saveEntryTypeDateField('primaryStatementPrintDate', value)
                      console.log(value)
                      this.validateField('primaryStatementPrintDate', value)
                    }}
                    onBlur={value => {
                      this.validateField('primaryStatementPrintDate', value)
                      autoAddPSPD();
                    }}
                  />
                  {/* {this.displayValidationErrors('primaryStatementPrintDate')} */}
                </Grid.Column>
              )}
          {
            (entryTypeValues.statementPaymentType === 'MONTHLY' || entryTypeValues.statementPaymentType === 'MONTHLY_BROKER')
            && (
                <Grid.Column
                  width={'3'}
                  className='monthly-prelim-print-date no-field-margin noBorderRadius lastCol noLeftBorders calendarMoveLeft'
                >
                  <InputField
                    isLabel={false}
                    id='primaryStatementPrintDate'
                    type='date'
                    label='Preliminary Statement Print Date'
                    className={'field-bg'}
                    labelClassName='city'
                    disabled={isActivePscChild ||  (this.state.enableForm === true ? false : isDisabled('entryTypeSection'))}
                    //value={entryTypeValues.primaryStatementPrintDate.epochs}
                    value={entryTypeValues.primaryStatementPrintDate.epochs ? new Date((new Date(entryTypeValues.primaryStatementPrintDate.epochs).getUTCMonth()+1)+"/"+new Date(entryTypeValues.primaryStatementPrintDate.epochs).getUTCDate()+'/'+new Date(entryTypeValues.primaryStatementPrintDate.epochs).getUTCFullYear()).getTime(): -999}
                    shipmentId={shipmentId}
                    errors={(entryTypeFields['primaryStatementPrintDate'].errors || []).concat(fieldValidation.validObjects_bl[`Entryqwqr${'primaryStatementPrintDate'}`] || [])}
                    onChange={value => {
                      value = value && new Date(value.toGMTString());
                      if (value && !isNaN(value.getTime())) {
                        value = value.getTime()
                        value = new Date(Date.UTC((new Date(value)).getFullYear(), (new Date(value)).getMonth(), (new Date(value)).getDate()))
                        value = value.getTime();
                      } else value = -999
                      updateEntryTypeObject(
                        'primaryStatementPrintDate',
                        'epochs',
                        value
                      )
                      saveEntryTypeDateField('primaryStatementPrintDate', value)
                      this.validateField('primaryStatementPrintDate', value)
                    }}
                    onBlur={value => {
                      this.validateField('primaryStatementPrintDate', entryTypeValues.primaryStatementPrintDate.epochs)
                      autoAddPSPD();
                    }}
                  />
                  {/* {this.displayValidationErrors('primaryStatementPrintDate')} */}
                </Grid.Column>
            )}
            {
              (entryTypeValues.clientBranch?.length > 0 || Object.keys(statementBranchHash).includes(entryTypeValues.filerCode)) && 
              entryTypeValues.statementPaymentType != "INDIVIDUAL" &&
              !hasPSC &&
              <Grid.Column width={'1'} className='port-field no-field-margin noLeftBorders noBorderRadius lastCol'
                  style={{overflow:'hidden'}}>
                <InputField
                  disabled={true}
                  isLabel={false}
                  id={`clientBranch`}
                  type='text'
                  label={`STATEMENT BRANCH`}
                  labelClassName='statementBranch'
                  className='field-bg'
                  shipmentId={shipmentId}
                  value={entryTypeValues.clientBranch?.length > 0 ? entryTypeValues.clientBranch : statementBranchHash[entryTypeValues.filerCode]}
                />
              </Grid.Column>
            }
            </Grid.Row>
        </Grid>
       <Grid className="no-gutters">
           <Grid.Row className="noTopBorders noBorderRadius">
           {/*  <Grid.Column width={'4'} className='port-field no-field-margin'>
           <InputField
                disabled={true}
                isLabel={false}
                id={`clientBranch`}
                type='text'
                label={`STATEMENT BRANCH`}
                labelClassName='city'
                className='field-bg'
                shipmentId={shipmentId}
                value={
                  entryTypeValues.clientBranch
                }
              />
            </Grid.Column> */}
            <Grid.Column width={'8'} className='port-field no-field-margin'>
              <SearchDropDown
                isLabel={false}
                id='portCode'
                type='text'
                label={"Port of Entry Code"}
                fieldType={"POE"}
                currentCountry_aa="US"
                labelClassName='city'
                className='field-bg noBorderRadius'
                value={entryTypeValues.portCode}
                onChange={value => {
                  if(!value.id)return;
                  if(!entryTypeValues?.portCode?.id){
                    updateEntryTypeField('portCode', value)
                    saveEntryTypeField(
                      'portCode',
                      value === '' ? '_BLANK_' : value.id
                    )
                    return;
                  }
                  confirmAlert({
                    title: `Confirm the new port of entry: ${value.id} - ${value.title}`,
                     message: <div><ul><li title={new Date(BOLInfo.itDate.epochs)+""}><b>IT Date: </b>{itDateHtml}</li>
                     <li><b>IT Number: </b>{itNumberHTML}</li>
                     <li><b>U.S. Port of Unlading: </b>{USportOfUnladingCode.id} - {USportOfUnladingCode.title}</li>
                     <li><b>Old Port: </b>{entryTypeValues.portCode.id}</li>
                     </ul></div>,
                    buttons: [
                      {
                        label: <b>Confirm</b>,
                        onClick: () => {
                          updateEntryTypeField('portCode', value)
                          saveEntryTypeField(
                            'portCode',
                            value === '' ? '_BLANK_' : value.id
                          )

                        }
                      },
                      {
                        label: `Cancel`,
                        onClick: () => {}
                      }
                    ]
                  }) 
                }}
                errors={(entryTypeFields['portCode'].errors ||[]).
                  concat( fieldValidation.validObjects_bl[`Entryqwqr${'portCode'}`] || [])}
                validate={this.validateField}
                portType ={modeOfTransport == "AIR"?"AIRPORT":"PORT"}
                onBlur={value => {
                  console.log('blurvalue: ', value);
                  autoAddPSPD();
                }}
                disabled={this.state.enableForm === true ? false : isDisabled('portOfEntryCodeEnabled')}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
                hidePrefix={modeOfTransport == "AIR"}
              />
              {/* {this.displayValidationErrors('portCode')} */}
            </Grid.Column>
            <Grid.Column width={'8'} className='thirdCol no-field-margin noLeftBorders'>
              <SearchDropDown
                id="USportOfUnladingCode"
                disabled={this.state.enableForm === true ? false : isDisabled('USportOfUnladingCode')}
                type="text"
                label={"U.S. Port of Unlading"}
                fieldType={"POUL"}
                className={"field-bg"}
                fullPayload={true}
                portType ={modeOfTransport == "AIR"?"AIRPORT":"PORT"}
                value={USportOfUnladingCode}
                currentCountry_aa="US"
                errors={transportationFields["USportOfUnladingCode"].errors}
                onChange={(value) => updateTransportationField("USportOfUnladingCode", value)}
                onBlur={(value, portKxId) => {
                  let newObj = {
                    USportOfUnlading: get(value, "title", "_BLANK_"),
                    USportOfUnladingCode: get(value, "payload", "_BLANK_"),
                    portKxId: get(value, "portKxId", "_BLANK_"),
                    destTimeZone:  get(value, "portTimeZone", "_BLANK_")
                  };
                  if(get(value, "airportTimeZone")){
                    newObj.destTimeZone = get(value, "airportTimeZone", "_BLANK_")
                  }
                  let USportOfUnladingCode = newObj.USportOfUnladingCode === '_BLANK_'?  "" : newObj.USportOfUnladingCode
                  this.validateField("USportOfUnladingCode", USportOfUnladingCode);
                  saveTransportationField("USportOfUnladingCode", newObj);
                  saveTransportationField("knlocidUnlading", newObj.portKxId);
                  if(newObj.destTimeZone && transportInfoValues.destTimeZone!== newObj.destTimeZone){
                    updateTransportationField("destTimeZone", newObj.destTimeZone);
                    saveTransportationField("destTimeZone", newObj.destTimeZone);
                      if(arrivalDate!=="-999" &&  newObj.destTimeZone && newObj.destTimeZone!='_BLANK_'){
                        try {
                      let differenceMsBetweenOldAndNew = convertToTimezone(arrivalDate,transportInfoValues.destTimeZone)
                        - convertToTimezone(arrivalDate,newObj.destTimeZone);
                        let newEpoch = arrivalDate + differenceMsBetweenOldAndNew;
                        // newObj.destTimeZone:  America/Los_Angeles
                        // transportInfoValues.destTimeZone:  America/Chicago
                        // arrivalDate:  1596301200000
                        updateTransportDate("arrivalDate", "epochs",  newEpoch)
                        saveTransportationDateField("arrivalDate",  newEpoch)
                        window.shipmentETA = newEpoch
                      }catch(e){
                        console.error("INVALID TIMEZONE",e)
                      }
                      }
                }
                autoAddPSPD();
                }}
                {...FIELD_META}
                hidePrefix={modeOfTransport == "AIR" }
              />
              {/* {this.displayValidationErrors('countryOfExport')} */}
              {/* <InputField
                isLabel={false}
                id='countryOfExport'
                type='text'
                label='Country of export'
                placeholder='Country of export'
                labelClassName='city'
                className='field-bg'
                value={entryTypeValues.countryOfExport}
                onChange={value =>
                  updateEntryTypeField('countryOfExport', value)
                }
                onBlur={value => saveEntryTypeField('countryOfExport', value)}
              /> */}
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className='fourColoumnMerge blk1 noBorderRadius noTopBorders'>
          <Grid.Column width={'3'} className='firstCol no-field-margin itValuesHeaderTab' title={'In-Transit (e.g, In-Bond) Number'}>
              <InputField
                disabled={this.state.enableForm === true ? false : isDisabled("itNumber")}
                isLabel={false}
                id={entryTypeFields.itNumber.id}
                type='text'
                label={entryTypeFields.itNumber.label}
                labelClassName='city'
                className='field-bg'
                shipmentId={shipmentId}
                clearInput={true}
                errors={fieldValidation.validObjects_bl["BolqwqritNumber"]}
                value={
                  bolInfoValues.itNumber === '_BLANK_'
                    ? ''
                    : bolInfoValues.itNumber
                }
                onChange={value =>{
                    updateBOLInfoField(entryTypeFields.itNumber.id, value)
                  }
                }
                onBlur={value => {
                  if (bolInfoValues.itDate.epochs && bolInfoValues.itDate.epochs !== -999) {
                    this.validateField(entryTypeFields.itNumber.id, value)
                  }
                  if (value === '') {
                    updateBOLInfoField(entryTypeFields.itNumber.id, '_BLANK_')
                    if (bolInfoValues.itDate &&
                      (!bolInfoValues.itDate.epochs ||
                        bolInfoValues.itDate.epochs === -999 ||
                        bolInfoValues.itDate.epochs === '')) {
                          entryTypeFields['itDate'].errors = []
                          entryTypeFields['itDate'].valid = true
                      this.removeErrorClass('itDate', entryTypeFields)
                    }
                  } else {
                    this.validateField(entryTypeFields.itDate.id, bolInfoValues.itDate.epochs)
                  }
                  saveBOLInfoField(entryTypeFields.itNumber.id, value === '' ? '_BLANK_' : value)
                  autoAddPSPD();
                }}
              />
            </Grid.Column>
            <Grid.Column width={'3'} className='secondCol datepicker itValuesHeaderTab' title={'In-Transit (e.g, In-Bond) Date'}>
              <InputField
                disabled={this.state.enableForm === true ? false : isDisabled(entryTypeFields.itDate.id)}
                icon={<Image src={Images.calender_icon} />}
                isLabel={false}
                id={entryTypeFields.itDate.id}
                type='date'
                label={entryTypeFields.itDate.label}//I.T. Date input, it date input
                className='field-bg'
                selected={false}
                shipmentId={shipmentId}
                //value={bolInfoValues.itDate.epochs}
                value={bolInfoValues.itDate.epochs ? new Date((new Date(bolInfoValues.itDate.epochs).getUTCMonth()+1)+"/"+new Date(bolInfoValues.itDate.epochs).getUTCDate()+'/'+new Date(bolInfoValues.itDate.epochs).getUTCFullYear()).getTime(): -999}
                errors={fieldValidation.validObjects_bl["BolqwqritDate"]}
                onChange={value => {
                  if (value && !isNaN(value.getTime())) {
                    value = value.getTime();
                    value = new Date(Date.UTC((new Date(value)).getFullYear(), (new Date(value)).getMonth(), (new Date(value)).getDate()))
                    updateITDateField(value.getTime())
                    saveBOLInfoField(entryTypeFields.itDate.id, value.getTime())
                    this.validateField(entryTypeFields.itDate.id, value)
                    this.validateField(entryTypeFields.itNumber.id, bolInfoValues.itNumber)
                  } else if (value === null) {
                    updateITDateField(-999)
                    saveBOLInfoField(entryTypeFields.itDate.id, -999)
                    if (bolInfoValues.itNumber && bolInfoValues.itNumber !== "_BLANK_") {
                      this.validateField(entryTypeFields.itDate.id, value)
                    }
                    this.validateField(entryTypeFields.itNumber.id, 'x')
                  }
                }}
              />
            </Grid.Column>
            <Grid.Column width={'3'} className='no-field-margin'>
              <SearchFirmList
                isLabel={false}
                id={entryTypeFields.locationOfGoods.id}
                disabled={this.state.enableForm === true ? false : isDisabled(entryTypeFields.locationOfGoods.id)}
                type='text'
                label={<span>
                  {entryTypeFields.locationOfGoods.label} 
                    <PopUpIcon basic={true} icon='info circle' popupText={entryTypeFields.locationOfGoods.info} />
                </span>}
                className='field-bg'
                noResultsMessage={bolInfoValues.locationOfGoods.length <= 2? 'Please enter minimum 3 characters' : 'No results found.'}
                value={bolInfoValues.locationOfGoods === '_BLANK_' ? "": bolInfoValues.locationOfGoods }
                errors={entryTypeFields[entryTypeFields.locationOfGoods.id].errors}
                onChange={value => {
                    let val = value || '_BLANK_';
                    let addressObject_p = (window.GLOBAL_ALL_FIRMS_LIST||[]).find(a=>a.ediid==val)
                    
                    updateBOLInfoField(
                      entryTypeFields.locationOfGoods.id,
                      val
                    )
                    if(addressObject_p){
                      updateBOLInfoField(
                        'terminalOfGoodsName',
                        addressObject_p.terminalName
                      )
                      updateBOLInfoField(
                        'terminalOfGoodsAddress',
                        addressObject_p.terminalAddress
                      )
                      
                      
                    }
                  }
                }
                onBlur={value => {
                  let val = value || '_BLANK_';
                  
                  this.validateField(entryTypeFields.locationOfGoods.id, val)
                  let addressObject_p = (window.GLOBAL_ALL_FIRMS_LIST||[]).find(a=>a.ediid==val)
                  if(addressObject_p){
                    saveBOLInfoObject('bolInfo',{
                      "locationOfGoods": val,
                      "terminalOfGoodsName": addressObject_p.terminalName,
                      "terminalOfGoodsAddress": addressObject_p.terminalAddress
                    })
                  } else {
                    saveBOLInfoObject('bolInfo',{
                      "locationOfGoods": "_BLANK_",
                      "terminalOfGoodsName": "_BLANK_",
                      "terminalOfGoodsAddress": "_BLANK_",
                    })
                    updateBOLInfoField(
                      entryTypeFields.locationOfGoods.id,
                      "_BLANK_"
                    )

                  }
                  autoAddPSPD();
                }}
                USportOfUnladingCode={USportOfUnladingCode}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
                country='United States'
              />
            </Grid.Column>
           { 
            showCurrentLocationOfGood ?
            <Grid.Column width={'3'} className='no-field-margin'>
              <SearchFirmList
                isLabel={false}
                id={entryTypeFields.currentLocationOfGood.id}
                disabled={this.state.enableForm === true ? false : isDisabled(entryTypeFields.currentLocationOfGood.id)}
                type='text'
                label={<span>
                  {entryTypeFields.currentLocationOfGood.label} 
                    <PopUpIcon basic={true} icon='info circle' popupText={entryTypeFields.currentLocationOfGood.info} />
                </span>}
                className='field-bg'
                noResultsMessage={bolInfoValues.currentLocationOfGood?.length <= 2? 'Please enter minimum 3 characters' : 'No results found.'}
                value={bolInfoValues.currentLocationOfGood === ' ' ? "": bolInfoValues.currentLocationOfGood }
                errors={entryTypeFields[entryTypeFields.currentLocationOfGood.id].errors}
                onChange={value => {
                  let val = value || ' ';
                    updateBOLInfoField(
                      entryTypeFields.currentLocationOfGood.id,
                      val
                    )
                  }
                }
                onBlur={value => {
                  let val = value || ' ';
                  
                  this.validateField(entryTypeFields.currentLocationOfGood.id, val)
                    saveBOLInfoObject(
                      'bolInfo',
                      {"currentLocationOfGood": val}
                    )
                }}
                USportOfUnladingCode={USportOfUnladingCode}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
                country='United States'
              />
            </Grid.Column>: null}
            <Grid.Column width={showCurrentLocationOfGood ? '4':'3'} className={`no-field-margin noLeftBorders ${showCurrentLocationOfGood ? 'lastCol' : ''}`}>
              <InputField
                disabled={this.state.enableForm === true ? false : isDisabled("goNumberDisable")}
                isLabel={false}
                id={"gonumberjj"+shipmentId}
                type='text'
                label={"G.O. Number"}
                className='field-bg'
                shipmentId={shipmentId}
                clearInput={true}
                value={
                  entryTypeValues.gonumber === '_BLANK_'
                    ? ''
                    : entryTypeValues.gonumber
                }
                onChange={value => {
                  updateEntryTypeField("gonumber", value)
                }}
                onBlur={value => {
                  saveEntryTypeField("gonumber", value === '' ? '_BLANK_' : value)
                }}
              />
            </Grid.Column>
            <Grid.Column width={'4'} className='lastCol no-field-margin'>
              <SearchFirmList
                isLabel={false}
                id={bolAwbFields.centralizedExaminationSite.id}
                disabled={this.state.enableForm === true ? false : isDisabled(bolAwbFields.centralizedExaminationSite.id)}
                label={"CES (Examination Location)"}
                className={'field-bg'}
                errors={bolAwbFields[bolAwbFields.centralizedExaminationSite.id].errors}
                value={
                  centralizedExaminationSite === '_BLANK_'
                    ? ''
                    : centralizedExaminationSite
                }
                // input={props.input}
                onChange={value =>
                  updateTransportationField(
                    bolAwbFields.centralizedExaminationSite.id,
                    value.replace(/[^a-zA-Z0-9]/g, '')
                  )
                }
                onBlur={value => {
                  this.validateField(bolAwbFields.centralizedExaminationSite.id, value)
                  saveTransportationField(bolAwbFields.centralizedExaminationSite.id, value)
                }}
                newValue={newValue}
                fieldName={fieldName}
                setINPUTID={setINPUTID}
                penClicked={penClicked}
                shipmentId={shipmentId}
                rbCounterID={rbCounterID}
                country='United States'
              />
              {/* {this.displayValidationErrors('centralizedExaminationSite')} */}
            </Grid.Column>
          </Grid.Row>
          {/* <Grid.Column padded='true' width={'16'}>
            <Checkbox
              id='liveEntryIndicator'
              className=''
              label='Live Entry Indicator'
              checked={entryTypeValues.liveEntryIndicator === '1'}
              onChange={() => {
                let value =
                  entryTypeValues.liveEntryIndicator === '1' ? '2' : '1'
                updateEntryTypeField('liveEntryIndicator', value)
                saveEntryTypeField('liveEntryIndicator', value)
              }}
              disabled={isDisabled('entryTypeSection')}
              onBlur={() =>
                saveEntryTypeField(
                  'liveEntryIndicator',
                  entryTypeValues.liveEntryIndicator
                )
              }
            />
          </Grid.Column> */}
        </Grid>
      </Form>
    )
  }
}

const mapStateToProps = state => ({
  entryTypeValues: state.EntryTypeInfo,
  transportInfoValues: state.TransportationInfo,
  dropDownValues: state.DropDownValues,
  newValue: state.FormValues.newValue,
  fieldName: state.FormValues.fieldName,
  setINPUTID: state.FormValues.setINPUTID,
  penClicked: state.FormValues.penClicked,
  rbCounterID: state.FormValues.rbCounterID,
  shipmentId: state.FormValues.shipmentId,
  countryList: state.DropDownValues.countryList,
  BOLInfo: state.BOLInfo,
  entryTypeList: state.DropDownValues.entryTypeList,
  USportOfUnladingCode: state.TransportationInfo.USportOfUnladingCode,
  formDisabled: state.FormValues.formDisabled,
  tabName: "entryType",
  fieldValidation: state.FieldValidation,
  pscChainRawResponse: state.PscChainRawResponse,
  pscData: state.PSC,
  bolInfoValues: state.BOLInfo,
  centralizedExaminationSite:
    state.TransportationInfo.centralizedExaminationSite,
  related: state.Importer.related,
  FIELD_META: {
    newValue: state.FormValues.newValue,
    rbCounterID: state.FormValues.newValue,
    fieldName: state.FormValues.fieldName,
    setINPUTID: state.FormValues.setINPUTID,
    penClicked: state.FormValues.penClicked,
    shipmentId: state.FormValues.shipmentId
  },
})

const mapDispatchToProps = {
  ...actionCreators
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EntryTypeForm)
